import { render, staticRenderFns } from "./ForceTfa.vue?vue&type=template&id=b7be6f2c&scoped=true"
import script from "./ForceTfa.vue?vue&type=script&lang=js"
export * from "./ForceTfa.vue?vue&type=script&lang=js"
import style0 from "./ForceTfa.vue?vue&type=style&index=0&id=b7be6f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7be6f2c",
  null
  
)

export default component.exports